import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../core/modules/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { DialogComponent } from '../dialog/dialog.component';
import { AuthGuard } from '../../../../_guards/auth.guard';
import { ComplaintsListComponent } from '../complaints-list/complaints-list.component';

const routes: Routes = [
    {
        path     : 'complaints-list',
        component: ComplaintsListComponent,
        canActivate:[AuthGuard]
    }
];

@NgModule({
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        ComplaintsListComponent,
        DialogComponent
    ],
    entryComponents: [DialogComponent],
    providers:[
        AuthGuard
    ]
})
export class ComplaintsListModule
{
}


// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/user-complaints/complaints-list/complaints-list.module.ts